module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/errors/ill-404-error4ee4c2edff8dda87fb4645bed555dc85.svg";